import getUsers from './getUsers'
import getClients from './getClients'

let inflight = null
export default function loadUsers() {
	if (inflight) return inflight
	inflight = Promise.all([getUsers(), getClients()]).finally(() => {
		inflight = null
	})
	return inflight
}
